import { isPhone, isWeb } from '@helpers';

export const gcd = (a: number, b: number): number => {
  return b === 0 ? a : gcd(b, a % b);
};

interface LayoutConfig {
  itemSize: number;
  boxStyle: Record<string, any>;
  columns: number;
}

const makeFlexBoxStyle = (paddingLeft: number, paddingRight: number) => ({
  paddingLeft,
  paddingRight,
  justifyContent: 'space-between' as const,
  flexDirection: 'row' as const,
  flexWrap: 'wrap' as const,
});

export const getLayoutConfig = (devWidth: number, devHeight: number): LayoutConfig => {
  let itemSize = 324;
  let boxStyle: Record<string, any> = {};
  let columns = 1;

  if (!isPhone) {
    const r = gcd(devWidth, devHeight);
    const ratio = devWidth / r / (devHeight / r);

    if (ratio >= 1.28 && ratio <= 1.98 && !isWeb) {
      if (ratio >= 1.28 || ratio <= 1.43) {
        columns = 3;
        const marginSum = 72;
        itemSize = (devWidth - marginSum) / 3;
        boxStyle = makeFlexBoxStyle(18, 18);
      }
      if (ratio >= 1.44 && ratio <= 1.77) {
        columns = 3;
        const marginSum = 144;
        itemSize = (devWidth - marginSum) / 3;
        boxStyle = makeFlexBoxStyle(36, 36);
      }
      if (ratio >= 1.78 && ratio <= 1.98) {
        columns = 4;
        const marginSum = 90;
        itemSize = (devWidth - marginSum) / 4;
        boxStyle = makeFlexBoxStyle(18, 18);
      }
    } else {
      if (devWidth < 1080) {
        columns = 3;
        itemSize = 336;
        const spaceCount = 4;
        const oneSpace = (1080 - columns * itemSize) / spaceCount;
        boxStyle = makeFlexBoxStyle(oneSpace, oneSpace);
      } else if (devWidth < 1241) {
        columns = 3;
        itemSize = 336;
        const spaceCount = 4;
        const oneSpace = (devWidth - columns * itemSize) / spaceCount;
        boxStyle = makeFlexBoxStyle(oneSpace, oneSpace);
      } else if (devWidth <= 1440) {
        columns = 4;
        const gutter = 18;
        const margin = 18;
        itemSize = (devWidth - gutter * 2 - (columns - 1) * margin) / columns;
        boxStyle = makeFlexBoxStyle(gutter, gutter);
      } else {
        columns = 4;
        itemSize = 306;
        const gutter = 18;
        boxStyle = makeFlexBoxStyle(gutter, gutter);
      }
    }
  } else {
    if (devWidth >= 360) {
      const baseSize = 324;
      const baseWidth = 360;
      const sacle = devWidth / baseWidth;
      itemSize = sacle * baseSize;
      const padding = (devWidth - itemSize) / 2;
      boxStyle = {
        paddingLeft: padding,
        paddingRight: padding,
        flexDirection: 'column' as const,
      };
    }
  }

  return { itemSize, boxStyle, columns };
};

export const isCloseToBottom = (layoutMeasurement: { height: number }, contentOffset: { y: number }, contentSize: { height: number }): boolean => {
  return layoutMeasurement.height + contentOffset.y >= contentSize.height - 1500;
};

export const padDataWithEmptyItems = <T>(data: T[], columns: number): (T | 'empty')[] => {
  if (!columns || columns <= 0) return data;
  const additions = columns - (data.length % columns);
  if (additions === columns) return data;
  return [...data, ...Array(additions).fill('empty')];
};
